module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creek-chat",
    class: {
      'creek-chat-open': _vm.windowOpen ? true : false, 'creek-chat-closed': _vm.windowOpen ? false : true
    },
    attrs: {
      "id": "Creek-Chat"
    }
  }, [_c('div', {
    staticClass: "creek-chat-inner-open"
  }, [_c('div', {
    staticClass: "creek-chat-messages-container"
  }, [_c('ul', {
    staticClass: "creek-chat-messages"
  }, _vm._l((_vm.messages), function(message) {
    return _c('li', [(message.type == 'message') ? _c('span', {
      staticClass: "creek-chat-message-username",
      domProps: {
        "textContent": _vm._s(message.username)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      class: 'creek-chat-message-type-' + message.type,
      domProps: {
        "textContent": _vm._s(message.content)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "creek-chat-message-time",
      domProps: {
        "textContent": _vm._s(message.timestampFormatted)
      }
    })])
  })), _vm._v(" "), _c('ul', {
    staticClass: "creek-chat-messages-typing"
  }, _vm._l((_vm.usersTyping), function(typing) {
    return _c('li', [_c('span', {
      domProps: {
        "textContent": _vm._s(typing.username)
      }
    }), _vm._v(" is typing.\n        ")])
  }))]), _vm._v(" "), (_vm.user.anonymous) ? _c('div', {
    staticClass: "creek-chat-username-container"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.l.startWithName)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputUsername),
      expression: "inputUsername"
    }],
    staticClass: "creek-chat-username-input",
    attrs: {
      "type": "text",
      "maxlength": "14",
      "placeholder": _vm.l.startWithNameInputPlaceholder
    },
    domProps: {
      "value": _vm._s(_vm.inputUsername)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.editUsername($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputUsername = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "creek-chat-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageInput),
      expression: "messageInput"
    }],
    staticClass: "creek-chat-message-input",
    attrs: {
      "placeholder": _vm.l.chatInputPlaceholder
    },
    domProps: {
      "value": _vm._s(_vm.messageInput)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.messageSend($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageInput = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "creek-chat-users-container"
  }, [_c('a', {
    staticClass: "creek-chat-exit",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.toggleChatOpen()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg"
  }), _vm._v(" Exit Chat")]), _vm._v(" "), _c('h2', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCount)
    }
  }), _vm._v(" user"), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCount > 1 ? 's' : '')
    }
  }), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "creek-chat-username"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputUsername),
      expression: "inputUsername"
    }],
    staticClass: "creek-chat-username-input",
    attrs: {
      "type": "text",
      "maxlength": "14",
      "placeholder": "Change username..."
    },
    domProps: {
      "value": _vm._s(_vm.inputUsername)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.editUsername($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "creek-chat-users"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      domProps: {
        "textContent": _vm._s(user.username)
      }
    })
  }))])]), _vm._v(" "), _c('a', {
    staticClass: "creek-chat-inner-closed",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.toggleChatOpen()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o fa-lg"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCount ? _vm.userCount : '1')
    }
  }), _vm._v(" user"), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCount > 1 ? 's' : '')
    }
  }), _vm._v(" in chat.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /usr/local/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-63a856c9!/usr/local/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!./client/CreekChat.vue
// module id = 160
// module chunks = 0